import React, { Component } from 'react'
import { Button, makeStyles } from '@material-ui/core';
import { PlayCircleOutline, GetAppOutlined } from '@material-ui/icons';

export default class DetailsTop extends Component {
    render() {
        const {movie, backdrop} =this.props.details;
        return (
            <div className="details-top" style={{backgroundImage:`url('https://image.tmdb.org/t/p/original/${backdrop}')`}}>
            <div className="details-data">
               <p className="title">{movie.Title}</p>
               <p className="type">{movie.Type} </p>
               <span className="detail"><span >{movie.Year}</span><span>18+</span><span>{movie.Language}</span><span className="last">{movie.Genre}</span></span>  
              <p className="about">{movie.Plot}</p>
              <p className="star"> <span> Starring: </span>  {movie.Actors}</p>
              <p className="creator"> <span>Creators: </span> {movie.Director}</p>
              <Button className="detail-button" startIcon={<PlayCircleOutline/>}  variant="contained">
                  Watch Now
              </Button>
              <Button variant="contained" startIcon={< GetAppOutlined />} className="detail-button">
                  Download
              </Button>
            </div>
          </div>
        )
    }
}
